/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EloquaCdoService {

  constructor(private http: HttpClient) { }

  getSyncs(): Observable<any> {
    return this.http
      .get(
        `/api/v1/cdosyncs`
      );
  }

  getSync(cdoSyncId: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/cdosync/${cdoSyncId}`
      );
  }

  setEnabled(cdoSyncId: string, enabled: boolean): Observable<any> {
    return this.http
      .put(
        `/api/v1/cdosync/${cdoSyncId}`,
        { enabled: enabled}
      );
  }

  setDeleted(cdoSyncId: string) {
    return this.http
      .put(
        `/api/v1/cdosync/${cdoSyncId}`,
        { enabled: false, deleted: true}
      );
  }

  savePartial(cdoSyncId: string, update: any): Observable<any> {
    return this.http
      .put(
        `/api/v1/cdosync/${cdoSyncId}`,
        update
      );
  }

  saveNew(cdoSync: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/cdosync`,
        cdoSync
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/eloqua-cdo.service.ts